import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export const fetchCampaignsAnalysis = async (params: {
  start: string;
  end: string;
}) => {
  return axiosPrivate.get('/reach/bulk_upload_all_campaign/', {
    params,
  });
};
